export default `<div>

    <p>As an SFC licensed corporation, we take our fiduciary responsibility to consider and disclose all material
        factors that may impact the risk-adjusted returns of our investments, including climate-related financial risks
        and opportunities.</p>



    <p>As an investor in the global economy, the scale and multi-faceted nature of climate change presents a systemic
        risk to our portfolio. Climate change impacts investors like us in two main ways:</p>



    <p>Physical impacts (e.g. wildfires, extreme weather, sea-level rise, drought) can affect our fixed assets (e.g.
        real estate) and disrupt portfolio companies' supply chains and operations. Climate change's acute and chronic
        physical impacts can affect people's health, food security, migration, water supply, and other ecosystem
        services in ways that could bring heightened volatility to financial markets and harm economic growth.</p>



    <p>Transition risks, or shifts in policies, technologies, industries, and customers, due to changed climate norms or
        movement toward a lower-carbon economy can affect the financial success of existing business models and
        industries. Our portfolio companies' long-term success depends on the degree to which they can successfully
        navigate the transition.</p>



    <p>Given our investment portfolio, frequency of trading and investment scope, we take climate-related risks into
        account in our investment and risk management process. In light of this, we are taking the necessary action to
        account for such risks, as explained below.</p>



    <p>As an SFC licensed corporation, it will regularly review the relevance and materiality of climate-related risks
        and assess once a year or when any major changes such as changes in the fund’s investment strategy or investment
        horizon occurred. Disclosure will be updated and provided to the investors if necessary.</p>



    <p>For funds which are deemed to be relevant of climate-related risk, the Company will take into accounts
        climate-related risks when making investment analysis and risk management. The Company will take appropriate
        measures to identify, assesses, manage and monitor the investments which is relevant and material to the
        climate-related risks.</p>



    <p>Considering the investment strategy and scope of the investment portfolios, the Company prepared a
        Climate-related risk assessment Questionnaire in conducting the qualitative material assessment. The Company
        consider requesting private equity investment companies to fill in the climate-related risk assessment
        questionnaire so that the Company can understand and analyze the climate-related risk and controls, targets and
        future climate-related improvements process of the target private equity firms. The Company should conduct
        regular monitoring of the climate-related risk and therefore the result of the questionnaire should be updated
        annually.</p>



    <p>The Company should take extra steps to monitor the companies which belong to environmentally sensitive industries
        and therefore additional questions should be asked to collect more information from those companies.</p>



    <p>In light of the above, Board members are informed annually on climate-related risks and opportunities and how
        these may influence decisions in relation to risk management, strategy setting, implementation and monitoring.
        This will include annual ESG report (if any), Climate-related risk assessment Questionnaire for all Portfolio.
    </p>



    <p>The governance structure of the Company consists of a.) supervising and overseeing of climate-related risk at the
        Board of Directors level and b.) planning, coordinating and promoting climate-related risk management at the
        management level.</p>



    <p>To integrate climate-related risk considerations into our existing governance structures, different roles and
        responsibilities have been assigned to ensure proper monitoring is in place:</p>



    <p><strong>Supervisory level</strong></p>

    <p>The Board of Directors is generally responsible for supervising the climate-related risk management process and
        relevant company development strategies. Its main responsibilities include:</p>



    <p>(i) Monitoring the status and progress of Company’s management efforts to incorporate climate related risks into
        the Company's investment and risk management processes;</p>

    <p>(ii) Setting and maintaining the high ethical standards and reputation of the Company;</p>

    <p>(iii) Reviewing the Company’s objectives in climate-related risk management and regularly checking the progress
        of achieving the objectives through Climate-related risk assessment Questionnaire.</p>

    <strong>Management level</strong>

    <p>The management team of the Company is responsible for developing, coordinating and promoting climate-related risk
        management. Its main responsibilities include:</p>



    <p>(i) Maintaining, reviewing and updating the climate-related risk management policy of the Company;</p>

    <p>(ii) Establishing the process for the management and Board of Directors to be regularly informed about the status
        and progress of efforts to manage climate-related risks;</p>

    <p>(iii) Formulating relevant processes for incorporating climate-related risks into the Company’s investment and
        risk management;</p>

    <p>(iv) Identifying and evaluating climate-related risks in the Company’s investment activities through
        climate-related data from external sources (if any).</p>



    <p>Through our engagement and advocacy efforts we are working to minimize the absolute risk from climate change to
        our portfolio. We also hope to understand the financial risks to our portfolio and prepare for the long-term
        changes that will accompany climate change through our research and integration efforts.</p>



    <p>We will continue to take reasonable steps to assess the impact of the aforesaid risks on the performance of the
        Company’s underlying investments to ensure compliance with the Hong Kong SFC’s related requirements on
        management and disclosure of climate-related risks by fund managers.. Our Board will also continue to thoroughly
        oversee the progress against goals for addressing climate-related issues.</p>



    <p>Should you have any queries, please do not hesitate to contact us in following method.
        <br>Email:operation@futurexcapital.com
        <br>Telephone number at 3166-4553
    </p>



    <p>FutureX Fund Management (Hong Kong) Limited</p>



    <p><em>Disclaimer: This disclosure statement is intended to provide information to stakeholders and by its nature
            may involve risk and uncertainty. This document may contain forward-looking statements. Any statements that
            may express forecasts, expectations and projections are not guarantees of future performance given the
            current uncertainties on this front.</em></p>
</div>`;
